export default __webpack_public_path__ + "static/media/eth.c378096f.svg";